module.exports = ".spinner-size {\r\n    height: 50px;\r\n    width: 50px;\r\n}"